
//BS
function BS(){
$('.bs').each(function(){
var t = $(this)
var d = t.attr('data-img')
if (t.hasClass('sw')){
var a =t.width()/t.attr('data-aspect')
t.height(a)
t.backstretch(d)
}else{
t.backstretch(d)
}
}); 
}



$(document).ready(function(){

  BS()
  
  
});//END DOC READY